var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCalendarBatchTag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5875 17.4125C0.979167 17.8042 1.45 18 2 18H8.675C8.525 17.7 8.39583 17.3833 8.2875 17.05C8.17917 16.7167 8.1 16.3667 8.05 16H2V2H16V8.075C16.35 8.125 16.6917 8.20417 17.025 8.3125C17.3583 8.42083 17.6833 8.55 18 8.7V2C18 1.45 17.8042 0.979167 17.4125 0.5875C17.0208 0.195833 16.55 0 16 0H2C1.45 0 0.979167 0.195833 0.5875 0.5875C0.195833 0.979167 0 1.45 0 2V16C0 16.55 0.195833 17.0208 0.5875 17.4125Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.075 14H4V12H8.675C8.54167 12.3167 8.42083 12.6417 8.3125 12.975C8.20417 13.3083 8.125 13.65 8.075 14Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1 10H4V8H14V8.075C13.25 8.19167 12.5458 8.41667 11.8875 8.75C11.2292 9.08333 10.6333 9.5 10.1 10Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 6H4V4H14V6Z",
    fill: "#333333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4625 18.5375C12.4375 19.5125 13.6167 20 15 20C16.3833 20 17.5625 19.5125 18.5375 18.5375C19.5125 17.5625 20 16.3833 20 15C20 13.6167 19.5125 12.4375 18.5375 11.4625C17.5625 10.4875 16.3833 10 15 10C13.6167 10 12.4375 10.4875 11.4625 11.4625C10.4875 12.4375 10 13.6167 10 15C10 16.3833 10.4875 17.5625 11.4625 18.5375ZM15.5 16H14.5V14.5H13V13.5H14.5V12H15.5V13.5H17V14.5H15.5V16ZM17 17H13V18H17V17Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendarBatchTag);
export default __webpack_public_path__ + "static/media/icon_calendar_batch_tag.4014f945aabcebf9391eefcaeab535ed.svg";
export { ForwardRef as ReactComponent };